import styled from 'styled-components'

const ManageInvitationsWrapper = styled.div`
    max-height: 540px;
    overflow-y: auto;
    margin-bottom: 10px;
`
const InvitationsRow = styled.div`
  min-height: 63px;
  border-bottom: solid 1px #c9c9c9;
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 20px 40px;
  align-items: center;
  h3 {
    font-size: 16px;
    font-family: "latomedium";
  }
  .action-btn {
    display: flex;
    gap: 34px;
    button {
      height: 40px;
      width: 98px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
      border: none;
      border-radius: 5px;
      color: #fff;
    }
    .pending {
      background-color: #868d91;
    }
  }
  @media (max-width: 650px) {
    padding: 15px 40px;

    h3 {
      font-size: 15px;
    }
  }
`;
export const Box = styled.div`
 border-bottom: solid 1px #87cdf1;
 cursor:pointer;
 display: flex;
align-items: center;
position: relative;
&:last-of-type{
    border-bottom:none;
}
 .dot {
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background-color: #0bb4ff;   
    display: block;
    position: absolute;
    left: 13px; 
    margin-top: 10px;
 }
    > div {
        display: flex;
        /* padding: 20px; */
        flex: 1
    }
`
export { ManageInvitationsWrapper, InvitationsRow }